import type { COLOR } from 'vars/color'
import type { IProgressBarProps } from './ProgressBar'
import type { Height } from './ProgressBar.h'

import { styled } from '@linaria/react'

export const Progress = styled.div<{
  progress: number
  height: Height
  colorDefault: COLOR
}>`
  width: ${({ progress }) => `${progress || 0}%`};
  max-width: 100%;
  height: ${({ height }) => (height ? `var(${height})` : 'auto')};
  background: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'none'};
  border-radius: inherit;
`

export const Track = styled.div<Omit<IProgressBarProps, 'ref'>>`
  width: ${({ width }) => (width ? `var(${width})` : '100%')};
  max-width: 100%;
  height: ${({ height }) => `var(${height})`};
  background: ${({ background }) =>
    background ? `var(${background})` : 'none'};
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};
`
